import React from "react";
import CustomDatePicker from "components/DatePicker";
import SimpleSelect, { SelectOption } from "components/SimpleSelect";
import { UPCOMING_OPERATION_LIST } from "features/Building/consts.d";
import { useTranslation } from "react-i18next";
import { buildingSettingsStore } from "../BuildingSettingsStore";
import { observer } from "mobx-react-lite";

const PlannedOperation = () => {
  const { t } = useTranslation();
  const { settings } = buildingSettingsStore;

  const operationListOptions = UPCOMING_OPERATION_LIST.map(
    (item: SelectOption) => ({
      ...item,
      disable: item.id === "1" && settings.is_existing,
    })
  );

  const currentOperation = settings.upcoming_operation
    ? operationListOptions.find(
        (item) => item.id === settings.upcoming_operation
      )?.id
    : undefined;

  const onChangeTypeOfOperation = (value: string | undefined | null) => {
    buildingSettingsStore.onChangeValue(value, "upcoming_operation");
    if (value != operationListOptions[0].id) {
      buildingSettingsStore.onChangeValue(true, "is_existing");
    }
  };

  return (
    <div>
      <div className="text-lg font-semibold mb-6">
        {t("buildingSettings.plannedOperation")}
      </div>
      <div className="flex gap-4">
        <SimpleSelect
          labelName={t("buildingSettings.typeOfMeasure")}
          options={operationListOptions}
          containerClassName="w-full"
          name="upcoming_operation"
          onChange={onChangeTypeOfOperation}
          placeholder={t("buildingSettings.selectOperationType")}
          current={currentOperation}
          disable={Boolean(!settings.is_existing)}
          helper={
            !settings.is_existing
              ? t("buildingSettings.typeOfMeasureHelper")
              : null
          }
        />
      </div>
      <div className="flex justify-between gap-4">
        <CustomDatePicker
          value={settings.start_date ?? ""}
          name="start_date"
          dateFormat="MM.yyyy"
          placeholder="MM.YYYY"
          maxDate={settings.end_date ?? ""}
          monthYearPicker
          onChange={buildingSettingsStore.onChangeValue}
          label={t("buildingSettings.plannedStart")}
        />
        <CustomDatePicker
          label={t("buildingSettings.plannedEnd")}
          monthYearPicker
          name="end_date"
          onChange={buildingSettingsStore.onChangeValue}
          dateFormat="MM.yyyy"
          placeholder="MM.YYYY"
          minDate={settings.start_date as string}
          value={settings.end_date ?? ""}
        />
      </div>
    </div>
  );
};

export default observer(PlannedOperation);
